import React, {useState, useEffect, useCallback} from "react";
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import { Area, ComposedChart } from 'recharts';
import 'react-calendar/dist/Calendar.css';
import MoveTopButton from "../MoveTopButton";
import { productServices } from "../../../api/services/products";
import { formatDate, formatDecimal, formatMillions } from "../../../helpers/format";
import { Table, DatePicker } from "antd";
import locale from 'antd/lib/date-picker/locale/es_ES';
import moment from 'moment';
import 'moment/locale/es'; 
import { useExportFiles } from '../../../hooks/main/useExportFiles';

const { RangePicker } = DatePicker;

const HistoricoTab = ({
    selectedProduct,
    showCalendarHist,
    setShowCalendarHist
}) => {

    const [calendarValue, setCalendarValue] = useState(null);

    const [showGraph, setShowGraph] = useState(true);

    const [historicalInfo, setHistoricalInfo] = useState([]);
    const [initialHistoricalInfo, setInitialHistoricalInfo] = useState([]);
    const [rentabilidad, setRentabilidad] = useState(null);
    const [detalleproducto, setDetalleproducto] = useState(null);

    const [dateRange, setDateRange] = useState([]);
    const [minValue, setMinValue] = useState(Infinity);
    const [maxValue, setMaxValue] = useState(-Infinity);
    const codProd = selectedProduct.codigo;
    const [rentaInfo, setRentaInfo] = useState([]);


    let initialData;
    let finalData;
    const dateFormatRent = "YYYY-MM-DD";
    const codProduct = selectedProduct.codigo;


    const dateFormat = "DD/MM/YYYY";
    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const columns = [
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'date',
            render: (text, record, idx) =>
                (record.holiday === 'N') ? (<p className="parraf-not-able">{formatDate(record.date)} <span className="text-not-able">(*)</span></p>) : (formatDate(record.date))
        },
        {
            title: "Valor Liquidativo",
            dataIndex: "liquidValue",
            key: "liquidValue",
            render: (liquidValue) => formatDecimal(liquidValue, 5),
        },
        {
            title: "Patrimonio",
            dataIndex: "patrimony",
            key: "patrimony",
            render: (patrimony) => formatMillions(patrimony),
        },
        {
            title: "Divisa",
            dataIndex: "currency",
            key: "currency",
        },
        ];

        let informeProductoURL;
        let datosFundamentalesURL;
        let datosFundamentalesURLDIP;
        let datosFundamentalesURLKIID;

        if (selectedProduct && selectedProduct.documentacion) {
          const { documentacion } = selectedProduct;
          let https = 'https';
          const baseURLBackend = process.env.BACKEND_ENDPOINT;
          const informeProducto = documentacion.filter(
              (doc) => doc.txdesdoc === "pdfInformeDeProducto"
          );
          informeProductoURL = informeProducto[0]?.urlcompleta || '-';

          const datosFundamentales = documentacion.filter(
              (doc) => doc.txdesdoc === "pdfFolletoExplicativo"
          );
          datosFundamentalesURL = datosFundamentales[0]?.urlcompleta || '-';

          if(datosFundamentales){
              datosFundamentalesURL = datosFundamentales[0]?.urlcompleta || '-' ;
              datosFundamentalesURL = datosFundamentalesURL.includes(https) === true ?
              datosFundamentalesURL
              : baseURLBackend + datosFundamentalesURL;
          }

          const datosFundamentalesKIID = documentacion.filter(
              (doc) => doc.txdesdoc === "pdfFolleto"
          );

          if(datosFundamentalesKIID){
              datosFundamentalesURLKIID = datosFundamentalesKIID[0]?.urlcompleta || '-' ;
              datosFundamentalesURLKIID = datosFundamentalesURLKIID.includes(https) === true ?
              datosFundamentalesURLKIID
              : baseURLBackend + datosFundamentalesURLKIID;
          }

          const datosFundamentalesDIP = documentacion.filter(
              (doc) => doc.txdesdoc === "pdfDocumentodeInformacionPrevia"
          );

          if(datosFundamentalesDIP){
              datosFundamentalesURLDIP = datosFundamentalesDIP[0]?.urlcompleta || '-' ;
              datosFundamentalesURLDIP = datosFundamentalesURLDIP.includes(https) === true ?
              datosFundamentalesURLDIP
              : baseURLBackend + datosFundamentalesURLDIP;
          }
        };

    const formatDateInfo = (dateMs) => {
        const msDate = new Date(dateMs);
        const dateFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return new Intl.DateTimeFormat('es-ES', dateFormatOptions).format(msDate);
    }

    const parseHistoricalInfo = (rawData) => {
        return rawData.map((rawDataItem) => {
            return {
                date: Date.parse(rawDataItem.fecha),
                liquidValue: rawDataItem.valorLiquidativo,
                patrimony: rawDataItem.patrimonio,
                currency: rawDataItem.divisa,
                holiday: rawDataItem.diaFestivo
            }
        })
    }

    const fetchHistoricalData = async (isin) => {
        try {
            return (await productServices.getHistorical(isin));
        } catch {
            return null;
        }
    };

    const {exportProductFilePdf, exportProductFileExcel} = useExportFiles(codProd);

    const createHistoricalInfo = useCallback(() => {
        const dataMap = new Map();
        let createMinValue = parseFloat(Infinity);
        let createMaxValue = parseFloat(-Infinity);

        const updateDataMap = (data, arrayIndex) => {
            data.forEach(item => {
                const { date, liquidValue, patrimony, currency, holiday } = item;
                if (!dataMap.has(date)) {
                    dataMap.set(date, {
                    });
                }
                dataMap.get(date)[`dateString`] = formatDateInfo(date);
                dataMap.get(date)[`liquidValue`] = liquidValue;
                dataMap.get(date)[`patrimony`] = patrimony;
                dataMap.get(date)[`currency`] = currency;
                dataMap.get(date)[`holiday`] = holiday;

                if (liquidValue < createMinValue) {
                    createMinValue = parseFloat(liquidValue);
                }
                if (liquidValue > createMaxValue) {
                    createMaxValue = parseFloat(liquidValue);
                }
            });
        };
        initialHistoricalInfo !== null && updateDataMap(initialHistoricalInfo, 1)
        const newHistoricalInfo = Array.from(dataMap, ([date, values]) => ({ date, ...values }));

        setMinValue(createMinValue);
        setMaxValue(createMaxValue);
        setHistoricalInfo(newHistoricalInfo);
    },[initialHistoricalInfo]);

    /*const calcularRentabilidadAnualizada = (initialData, finalData) => {
      const valorLiquidativoInicial = parseFloat(initialData.liquidValue);
      const valorLiquidativoFinal = parseFloat(finalData.liquidValue);

      const tasaCrecimientoTotal =
        (valorLiquidativoFinal - valorLiquidativoInicial) /
        valorLiquidativoInicial;

      const fechaInicial = new Date(initialData.date);
      const fechaFinal = new Date(finalData.date);
      const diasTranscurridos =
        (fechaFinal - fechaInicial) / (24 * 60 * 60 * 1000);

      const tasaCrecimientoAnualizada =
        Math.pow(1 + tasaCrecimientoTotal, 365 / diasTranscurridos) - 1;

      return !isNaN(tasaCrecimientoAnualizada)
        ? (tasaCrecimientoAnualizada * 100).toFixed(2) + "%"
        : "-";
    };*/

    /*const onSelectedDate = (date) =>{
        setCalendarValue(date);
        setShowCalendarHist(false);
        initialData = moment(date[0]).format(dateFormatRent);
        finalData = moment(date[1]).format(dateFormatRent);
        //productServices.getRentaResume(detalleproducto?.isin, initialDate, endDate);
        fetchRentaResume(codProduct, initialData, finalData);
        handleSearchRenta();
    }*/

    const onSelectedDate = (date) => {
        // Si el usuario borra las fechas (date === null o vacío)
        if (!date || date.length === 0) {
            // Definimos un rango por defecto (por ejemplo, mes actual)
            const start = moment().startOf('month');
            const end = moment().endOf('month');

            setCalendarValue([start, end]);

            // ejecutamos la misma lógica que normalmente
            initialData = start.format(dateFormatRent);
            finalData = end.format(dateFormatRent);

            fetchRentaResume(codProduct, initialData, finalData);
            handleSearchRenta();

            return; // salimos aquí
        }

        // Lógica normal si el usuario selecciona fechas válidas
        setCalendarValue(date);
        setShowCalendarHist(false);

        initialData = moment(date[0]).format(dateFormatRent);
        finalData = moment(date[1]).format(dateFormatRent);

        fetchRentaResume(codProduct, initialData, finalData);
        handleSearchRenta();
    }

    useEffect(() => {
        // define el rango inicial que quieras usar, por ejemplo el mes actual:
        const start = moment().startOf('month');
        const end = moment().endOf('month');

        // lo guardas en el estado del calendario
        setCalendarValue([start, end]);

        // llamas a tu función exactamente igual que si el usuario seleccionara esas fechas
        onSelectedDate([start, end]);
    }, []); // ← [] asegura que solo se ejecute una vez al montar

    const fetchRentaResume = async (codProduct, initialDate, endDate) => {
        try {
            return await productServices.getRentaResume(
            codProduct,
            initialData,
            finalData,
            selectedProduct.detalleproducto?.tipo
            );
        } catch {
            return null;
        }
    };

    const handleSearchRenta = () => {
        if (!initialData) {
            //setShowErrorMessage(true);
            return;
        }
        fetchRentaResume(codProduct, initialData, finalData).then((response) => {
            if(response) {
                setRentaInfo([
                    {
                        title: "Valor inicial",
                        date: null,
                        value: response.rentabilidadfechas.valorinicial ? formatDecimal(response.rentabilidadfechas.valorinicial, 5) : '-',
                    },
                    {
                        title: "Valor final",
                        date: null,
                        value: response.rentabilidadfechas.valorfinal ? formatDecimal(response.rentabilidadfechas.valorfinal, 5) : '-',
                    },
                    {
                        title: response.rentabilidadfechas.diasCalc > 365 ? "TAE" : "Acumulado",
                        date: null,
                        value: response.rentabilidadfechas.diasCalc > 365
                        ? response.rentabilidadfechas.tae ? `${formatDecimal(response.rentabilidadfechas.tae, 2)}%` : '-'
                        : response.rentabilidadfechas.acumulado && response.rentabilidadfechas.acumulado !== '-' ? `${formatDecimal(response.rentabilidadfechas.acumulado, 2)}%` : '-'
                    }
                    ]);
                    //setShowRentaInfo(true);
            }
        })
        }

    /*const addPercentLabel= (value) => {
        return value !== "-" ? value + '%' : value = "";
    };*/

    /*const calcularRentabilidadAcumulada = (response, initialData, finalData) => {
      let rentabilidadAcumulada = 0;
      let valorLiquidativoAnterior = parseFloat(initialData.liquidValue);

      for (let i = 1; i < response.length; i++) {
        const valorLiquidativoActual = parseFloat(response[i].liquidValue);
        const variacionDiaria =
          valorLiquidativoActual - valorLiquidativoAnterior;
        rentabilidadAcumulada += variacionDiaria;
        valorLiquidativoAnterior = valorLiquidativoActual;
      }

      return !isNaN(rentabilidadAcumulada) && rentabilidadAcumulada > 0
        ? rentabilidadAcumulada.toFixed(2) + "%"
        : "-";
    };*/

    const getInfoFilterByDates = (historicalInfo) => {
        if (dateRange !== null) {
          let filtrado = historicalInfo.filter((data) => {
            const date = moment(data.dateString, dateFormat);
            return date.isBetween(dateRange[0], dateRange[1], null, "[]");
          });

          return filtrado;
        } else {
          return historicalInfo;
        }
      };

    /*const getRentaInfo = (historicalInfo) => {
      if (historicalInfo.length > 0) {
        const initialData = historicalInfo[0];
        const initialDate = formatDateInfo(initialData.date);
        const initialValue = formatDecimal(initialData.liquidValue, 5);
        const finalData = historicalInfo[historicalInfo.length - 1];
        const finalDate = formatDateInfo(finalData.date);
        const finalValue = formatMillions(finalData.liquidValue, 5);

        const daysDifference = Math.floor((finalData.date - initialData.date) / (1000 * 60 * 60 * 24));

        return [
          {
            title: "Valor liquidativo inicial",
            date: initialDate,
            value: initialValue ?? '-',
          },
          {
            title: "Valor liquidativo final",
            date: finalDate,
            value: finalValue,
          },
          {
            title: daysDifference > 365 ? "Rentabilidad anualizada" : "Rentabilidad acumulada",
            date: null,
            value: daysDifference > 365 ? calcularRentabilidadAnualizada(initialData, finalData) : calcularRentabilidadAcumulada(historicalInfo, initialData, finalData)
          }
        ];
      } else {
        return [];
      }
    };*/

    /*const onSelectedDate = (dates) =>{
      setDateRange(dates);
    }*/

    /*const rentaInfo =
      dateRange !== null && dateRange.length === 0
        ? getRentaInfo(historicalInfo)
        : getRentaInfo(getInfoFilterByDates(historicalInfo));*/

    const filteredData =
      dateRange !== null && dateRange.length === 0
        ? historicalInfo
        : getInfoFilterByDates(historicalInfo);

    useEffect(() => {
      setInitialHistoricalInfo(initialHistoricalInfo);
      setRentabilidad(selectedProduct?.rentabilidad);
      createHistoricalInfo();
    }, [initialHistoricalInfo, createHistoricalInfo, selectedProduct?.rentabilidad]);

    useEffect(() => {
      if (selectedProduct !== null) {
        const codProduct = selectedProduct.codigo;
        fetchHistoricalData(codProduct).then((response) => {
          if (response && response.response && showGraph === true) {
            setInitialHistoricalInfo(
              parseHistoricalInfo(response.response).sort(
                (a, b) => a.date - b.date
              )
            );
          } else if(response && response.response && showGraph === false) {
            setInitialHistoricalInfo(
              parseHistoricalInfo(response.response).sort(
                (a, b) => b.date - a.date
              )
            );
          } else {
            setInitialHistoricalInfo([]);
          }
        });
      } else {
        setInitialHistoricalInfo([]);
      }
    }, [selectedProduct, showGraph]);

    return (
        <div data-testid="pagina-historico" style={{marginTop: 10}}>
            <h4 className="blueText">Evolución</h4>
            <div>

            </div>
            <div className="row" style={{marginTop: 30, marginBottom: 30}}>
                <div className="col-lg-6 col-md-6 col-sm-6">{/*Fecha de última valoración: */}</div>
                <div className="col-lg-6 col-md-6 col-sm-6" style={{textAlign:"right"}}>
                    <span style={{color: 'red', fontSize: 16, marginBottom: 10, fontWeight: 500}}>
                        <span style={{marginRight: 30, color: 'black'}}>
                            Exportar a:
                        </span>
                        <span style={{marginRight: 30, cursor: 'pointer'}} onClick={() => exportProductFilePdf(codProd)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M13.5 2H5.5C5.22363 2 5 2.22363 5 2.5V10L4.83922 10.0055C3.81239 10.0815 3 10.9414 3 11.9873V16.0127L3.00546 16.1608C3.08148 17.1876 3.94141 18 4.9873 18H5V21.5L5.00805 21.5899C5.05035 21.8233 5.25434 22 5.5 22H18.5L18.5899 21.992C18.8233 21.9497 19 21.7457 19 21.5V18L19.1608 17.9945C20.1876 17.9185 21 17.0586 21 16.0127V11.9873L20.9945 11.8392C20.9185 10.8124 20.0586 10 19.0127 10H19V7.51562L18.9921 7.42898C18.9715 7.31687 18.9118 7.21929 18.8296 7.146L13.9025 2.21893L13.8422 2.14662C13.754 2.05754 13.6356 2 13.5 2ZM6 18H18V21H6V18ZM19.0127 11H4.9873C4.48221 11 4.06385 11.3823 4.00666 11.8724L4 11.9873V16.0127C4 16.5178 4.38228 16.9361 4.87241 16.9933L4.9873 17H19.0127C19.5178 17 19.9361 16.6177 19.9933 16.1276L20 16.0127V11.9873C20 11.4822 19.6177 11.0639 19.1276 11.0067L19.0127 11ZM9.69678 12.3735C9.44775 12.1313 9.03955 12.0112 8.47412 12.0112C8.30615 12.0112 8.12061 12.02 7.91846 12.0386L7.54599 12.0815L7.38428 12.106V15.9946H8.11475V14.7026H8.53662L8.72611 14.6957C8.97123 14.6773 9.18623 14.6222 9.37061 14.5308C9.60107 14.4165 9.7749 14.2563 9.89307 14.0503C10.0112 13.8442 10.0698 13.603 10.0698 13.3257C10.0698 12.9321 9.9458 12.6147 9.69678 12.3735ZM11.7495 12.0054C12.4243 12.0054 12.9204 12.1851 13.2388 12.5444C13.5571 12.9038 13.7163 13.3931 13.7163 14.0112C13.7163 14.4312 13.6431 14.7886 13.4976 15.0845C13.3511 15.3804 13.1343 15.606 12.8452 15.7612C12.6051 15.8906 12.3169 15.9664 11.98 15.9881L11.772 15.9946H10.6147V12.1118C10.9409 12.0405 11.3188 12.0054 11.7495 12.0054ZM16.614 12.2039L16.6157 12.106H14.3403V15.9946H15.0708V14.3647H16.4136L16.4311 14.2729C16.442 14.2077 16.4513 14.1346 16.4585 14.0532L16.468 13.9371L16.4751 13.7358H15.0708V12.73H16.5542L16.5717 12.6386C16.5826 12.5741 16.592 12.5024 16.5991 12.4243L16.614 12.2039ZM11.7554 12.6343C11.6558 12.6343 11.5618 12.6377 11.4735 12.6444L11.3452 12.6567V15.3657H11.7896C12.1899 15.3657 12.4839 15.2544 12.6714 15.0308C12.8589 14.8081 12.9526 14.4683 12.9526 14.0112C12.9526 13.5581 12.856 13.2153 12.6626 12.9829C12.4702 12.7505 12.1675 12.6343 11.7554 12.6343ZM8.30176 12.6176L8.4917 12.6118C9.0415 12.6118 9.31689 12.8589 9.31689 13.354C9.31689 13.5894 9.25049 13.7739 9.11768 13.9077C8.98486 14.0405 8.78857 14.1069 8.53076 14.1069H8.11475V12.6343L8.30176 12.6176ZM13.0023 3H6V10H18V8.01367L13.5215 8C13.2776 7.99913 13.0745 7.82388 13.0317 7.59153L13.0234 7.50195L13.0023 3ZM14.0215 7.00195L14.0059 3.73639L17.2814 7.0119L14.0215 7.00195Z" fill="#EC0000"/>
                            </svg>
                            PDF
                        </span>
                        <span style={{cursor: 'pointer'}} onClick={() => exportProductFileExcel(codProd)}>
                            <svg width="60" height="32" viewBox="0 0 60 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M13.5 7H5.5C5.22363 7 5 7.22363 5 7.5V15L4.83922 15.0055C3.81239 15.0815 3 15.9414 3 16.9873V21.0127L3.00546 21.1608C3.08148 22.1876 3.94141 23 4.9873 23H5V26.5L5.00805 26.5899C5.05035 26.8233 5.25434 27 5.5 27H18.5L18.5899 26.992C18.8233 26.9497 19 26.7457 19 26.5V23L19.1608 22.9945C20.1876 22.9185 21 22.0586 21 21.0127V16.9873L20.9945 16.8392C20.9185 15.8124 20.0586 15 19.0127 15H19V12.5156L18.9921 12.429C18.9715 12.3169 18.9118 12.2193 18.8296 12.146L13.9025 7.21893L13.8422 7.14662C13.754 7.05754 13.6356 7 13.5 7ZM6 23H18V26H6V23ZM19.0127 16H4.9873C4.48221 16 4.06385 16.3823 4.00666 16.8724L4 16.9873V21.0127C4 21.5178 4.38228 21.9361 4.87241 21.9933L4.9873 22H19.0127C19.5178 22 19.9361 21.6177 19.9933 21.1276L20 21.0127V16.9873C20 16.4822 19.6177 16.0639 19.1276 16.0067L19.0127 16ZM16.2397 17.1343C15.9399 17.0142 15.6011 16.9546 15.2231 16.9546C14.9038 16.9546 14.6411 17.0024 14.4331 17.0981C14.2251 17.1929 14.0728 17.3228 13.9751 17.4858C13.8774 17.6479 13.8296 17.8364 13.8296 18.0503C13.8296 18.3423 13.9019 18.5757 14.0483 18.7495C14.1948 18.9243 14.4028 19.0669 14.6724 19.1792L14.9927 19.314L15.2114 19.4104C15.2751 19.4409 15.3296 19.4697 15.3745 19.4966C15.4644 19.5513 15.5317 19.6118 15.5767 19.6792C15.6216 19.7466 15.644 19.8315 15.644 19.9321C15.644 20.0933 15.5796 20.2173 15.4507 20.3032C15.3208 20.3892 15.1421 20.4321 14.9136 20.4321C14.7485 20.4321 14.5776 20.4116 14.3999 20.3706C14.2212 20.3296 14.061 20.272 13.9194 20.1968C13.8931 20.2974 13.8745 20.395 13.8628 20.4888L13.8455 20.6935L13.8403 20.8091C13.9683 20.8804 14.1274 20.937 14.3208 20.98C14.5142 21.0229 14.7114 21.0454 14.9136 21.0454C15.2319 21.0454 15.5015 20.9956 15.7231 20.896C15.9438 20.7974 16.1108 20.6597 16.2231 20.4829C16.3354 20.3071 16.3911 20.1069 16.3911 19.8823C16.3911 19.5864 16.3101 19.3491 16.147 19.1714C15.9839 18.9937 15.7603 18.8501 15.4751 18.7417L15.0096 18.5604C14.9306 18.5264 14.8651 18.493 14.813 18.4604C14.7339 18.4116 14.6753 18.354 14.6353 18.2866C14.5962 18.2183 14.5767 18.1343 14.5767 18.0337C14.5767 17.8911 14.6304 17.7769 14.7397 17.6909C14.8481 17.604 15.02 17.561 15.2563 17.561C15.3911 17.561 15.5376 17.5757 15.6948 17.603C15.8521 17.6313 16.0034 17.6733 16.1499 17.73C16.1724 17.6323 16.1909 17.5356 16.2056 17.4409C16.2212 17.3452 16.2319 17.2427 16.2397 17.1343ZM8.54736 17.0552L9.28955 18.3091L10.0083 17.0552H10.8286L9.66064 18.9155L10.9185 20.9438H10.0874L9.26123 19.562L8.43506 20.9438H7.60889L8.896 18.9546L7.71631 17.0552H8.54736ZM12.1489 20.3091V17.0054L12.0262 17.0083C11.9425 17.0123 11.8553 17.0203 11.7642 17.0327C11.6274 17.0522 11.5122 17.0747 11.4185 17.1001V20.9438H13.4634L13.4849 20.7899L13.5034 20.6206C13.507 20.5812 13.5103 20.5435 13.5131 20.5073L13.5259 20.3091H12.1489ZM13.0023 8H6V15H18V13.0137L13.5215 13C13.2776 12.9991 13.0745 12.8239 13.0317 12.5915L13.0234 12.502L13.0023 8ZM14.0215 12.002L14.0059 8.73639L17.2814 12.0119L14.0215 12.002Z" fill="#EC0000"/>
                            <path d="M42.928 23L40.256 18.456L37.536 23H35.952L39.552 17.288L36.24 11.928H37.84L40.288 16.04L42.704 11.928H44.288L40.992 17.208L44.528 23H42.928ZM45.732 12.024C45.9347 11.96 46.164 11.9067 46.42 11.864C46.6867 11.8213 46.9267 11.8 47.14 11.8V21.736H51.412C51.3907 22.184 51.3427 22.6053 51.268 23H45.732V12.024ZM55.0516 23.24C54.5076 23.24 53.985 23.1813 53.4836 23.064C52.9823 22.9467 52.545 22.776 52.1716 22.552C52.193 22.2747 52.2143 22.0453 52.2356 21.864C52.2676 21.6827 52.3103 21.5067 52.3636 21.336C52.7583 21.56 53.1956 21.7307 53.6756 21.848C54.1556 21.9653 54.6196 22.024 55.0676 22.024C55.825 22.024 56.417 21.864 56.8436 21.544C57.2703 21.224 57.4836 20.776 57.4836 20.2C57.4836 19.816 57.3876 19.4907 57.1956 19.224C57.0143 18.9467 56.7796 18.7227 56.4916 18.552C56.2036 18.3813 55.857 18.216 55.4516 18.056L54.6356 17.736C53.857 17.416 53.2543 17.0107 52.8276 16.52C52.401 16.0293 52.1876 15.3893 52.1876 14.6C52.1876 13.6827 52.4916 12.968 53.0996 12.456C53.7183 11.944 54.625 11.688 55.8196 11.688C56.8223 11.688 57.729 11.8587 58.5396 12.2C58.529 12.4347 58.5076 12.6427 58.4756 12.824C58.4436 12.9947 58.3956 13.176 58.3316 13.368C57.9263 13.2187 57.5103 13.1067 57.0836 13.032C56.657 12.9467 56.2516 12.904 55.8676 12.904C55.121 12.904 54.561 13.0533 54.1876 13.352C53.8143 13.6507 53.6276 14.056 53.6276 14.568C53.6276 15.1013 53.793 15.5227 54.1236 15.832C54.4543 16.1307 54.897 16.392 55.4516 16.616L56.2996 16.936C57.1103 17.2453 57.7503 17.6453 58.2196 18.136C58.6996 18.6267 58.9396 19.2933 58.9396 20.136C58.9396 20.744 58.7903 21.2827 58.4916 21.752C58.2036 22.2107 57.7663 22.5733 57.1796 22.84C56.6036 23.1067 55.8943 23.24 55.0516 23.24Z" fill="#EC0000"/>
                            </svg>
                        </span>
                    </span>
                </div>
            </div>
            <div className="d-flex">
                {<div className="w-50">
                    <div className='search-center-dropdown main-search'
                        style={{maxWidth: 350, marginBottom: 10}}
                        >
                        <RangePicker
                                locale={locale}
                                format={dateFormat}
                                className="date-picker d-flex"
                                onClick={() => {setShowCalendarHist(true);}}
                                onChange={onSelectedDate}
                            />
                    </div>
                    {
                        showCalendarHist
                    }
                </div>}
                {
                    calendarValue &&
                    <span style={{marginLeft: 30, top: 10, position: 'relative'}}>{calendarValue[0].date() + ' ' + months[calendarValue[0].month()]+ ' ' + calendarValue[0].year()} - {calendarValue[1].date() + ' ' + months[calendarValue[1].month()] + ' ' + calendarValue[1].year()} </span>
                }

            </div>
            <div className="row">
                { rentaInfo.length > 0 && rentaInfo.map((e, idx) =>
                    <div className="col-lg-3 col-md-3 col-sm-6" key={idx} style={{padding: 10}}>
                        <div style={{cursor: 'default', textAlign: 'left', maxWidth: '90%', margin: 0, height: 112}}>
                            <div style={{fontSize: 18, fontWeight: 600, marginBottom: 5}}>{e.value}</div>
                            <div>{e.title}</div>
                            {e.date && <div style={{fontSize: 12, marginTop: 10}}>{e.date}</div>}
                        </div>
                    </div>
                )}
            </div>
            { filteredData.length > 0 &&
            <div style={{textAlign: 'right'}}>
            <span style={{marginRight: 20, color: showGraph ? 'red': 'black'}} onClick={() => setShowGraph(true)}>Ver gráfica <i className="fa-solid fa-chart-simple"></i></span>
            <span style={{color: showGraph ? 'black': 'red'}} onClick={() => setShowGraph(false)}>Ver lista <i className="fa-solid fa-list"></i></span>
        </div>
            }

            {
                showGraph && filteredData.length > 0?
                <div id="graph" style={{ width: 'auto', height: 610, paddingTop: 30}}>
                    <ResponsiveContainer width="100%" height={400}>
                        <ComposedChart
                            data={filteredData}
                           >
                            <CartesianGrid strokeDasharray="3 3" />
                            <Legend />
                            <Tooltip />
                            <XAxis dataKey="dateString" />
                            <YAxis
                                type="number"
                                domain={[minValue , maxValue]}
                                tickFormatter={(tick) => tick.toFixed(2)}
                            />
                            <Area key={1} name='Valor liquidativo' dataKey="liquidValue" fill="#ebd1d1" stroke="#9c1918" />
                        </ComposedChart>
                    </ResponsiveContainer>
                    <div className="legal-text">
                    {rentabilidad?.fechainiciopolitica ? (
                        <p>
                          (*) El día {formatDate(rentabilidad?.fechainiciopolitica)} se produjo un cambio sustancial de política de inversión, por lo que sólo se muestra la evolución del valor liquidativo y rentabilidad desde esa fecha.
                        </p>
                    ) : null}
                    {
                        (selectedProduct?.detalleproducto?.tipo === `epvs` ?
                            <p>
                            Para más información puede acceder al <a href={datosFundamentalesURLDIP} target="blank">Documento de Información Previa (DIP)</a>.
                            </p>
                        : ""
                        )
                    }
                    {
                        (selectedProduct?.detalleproducto?.tipo === `fondos` ?
                            <p>
                            Para más información puede acceder al <a href={datosFundamentalesURL} target="blank">Documento de Datos Fundamentales (DDF)</a>.
                            </p>
                        : ""
                        )
                    }
                    {
                        ( selectedProduct?.detalleproducto?.tipo === `planes` ?
                            <p>
                            Para más información puede acceder al <a href={informeProductoURL} target="blank">Documento de Datos Fundamentales para el Partícipe (DDFP)</a>.
                            </p>
                        : ""
                        )
                    }
                    {
                        (selectedProduct?.detalleproducto?.tipo === `sicav` ?
                            <p>
                            Para más información puede acceder al <a href={datosFundamentalesURLKIID} target="blank">Datos Fundamentales para el Inversor (KIID)</a>.
                            </p>
                        : ""
                        )
                    }
                    <p>Rentabilidades superiores a un año son TAE.</p>
                    <p><strong>Rentabilidades pasadas no presuponen en ningún caso rentabilidades futuras. Cualquier referencia a resultados pasados no deberá interpretarse como una indicación de resultados futuros. Toda inversión en mercados financieros está sujeta a riesgos, incluido el riesgo de pérdida del principal invertido.</strong> Entre ellos cabe mencionar, a título enunciativo y no limitativo, riesgos de mercado, de crédito, de emisor y contrapartida, de liquidez, de cambio de moneda por fluctuaciones de valor y a la posible pérdida del capital invertido. Asimismo, cualquier decisión de suscripción sobre participaciones de las instituciones de inversión colectiva a las que se alude en este apartado, debería adoptarse teniendo en cuenta el documento que recoge los
                    {
                        (selectedProduct?.detalleproducto?.tipo === `epvs` ?
                            <a href={datosFundamentalesURLDIP} target="blank"> Documento de Información Previa (DIP)</a>
                        : ""
                        )
                    }
                    {
                        (selectedProduct?.detalleproducto?.tipo === `fondos` ?
                            <a href={datosFundamentalesURL} target="blank"> Documento de Datos Fundamentales (DDF)</a>
                        : ""
                        )
                    }
                    {
                        (selectedProduct?.detalleproducto?.tipo === `planes` ?
                            <a href={informeProductoURL} target="blank"> Documento de Datos Fundamentales para el Partícipe (DDFP).</a>
                        : ""
                        )
                    }
                    {
                        (selectedProduct?.detalleproducto?.tipo === `sicav` ?
                            <a href={datosFundamentalesURLKIID} target="blank"> Datos Fundamentales para el Inversor (KIID)</a>
                        : ""
                        )
                    }
                    . Este documento debe ser consultado por el inversor con carácter previo a cualquier decisión de inversión, suscripción o desinversión y le ayudará a comprender la naturaleza y los riesgos que conlleva invertir en la IIC.</p>
                </div></div>
                : filteredData.length > 0 ? 
                <div className="mt-4">
                    <span className="text-not-able">(*) Día no hábil</span>
                    <Table
                        showSorterTooltip={{ title: 'Clic para ordenar' }}
                        columns={columns}
                        dataSource={filteredData}
                        rowKey="fecha"
                    />
                </div>
                :
                <section className='search-table'>
                    <p className='error-message'>No hay datos para la consulta</p>
                </section>
            }
            <MoveTopButton />
        </div>
    );
};

export default HistoricoTab;
